import React__default from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import { usePrescriptionFormInput } from '../../context/PrescriptionFormInputContext.js';

const PrescriptionFormInputLabel = ({ children , isHiddenVisually  })=>{
    const { labelId , selectId , name  } = usePrescriptionFormInput();
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('prescription-form-input-label', {
            'prescription-form-input-label--hidden-visually': isHiddenVisually
        })
    }, /*#__PURE__*/ React__default.createElement("label", {
        id: labelId,
        htmlFor: selectId,
        className: "prescription-form-input-label__label"
    }, getLabel(`products.glasses.prescription.${name}`)), children);
};

export { PrescriptionFormInputLabel };
//# sourceMappingURL=PrescriptionFormInputLabel.js.map
